import { useInfiniteTableItems } from "@/app/components/infinite-table/use-infinite-table-items"
import { useMemo } from "react"
import { useUserBidsQueryResultReatom as useUserBidsQueryResult } from "../hooks.reatom"

export const useTableItems = () => {
  const query = useUserBidsQueryResult()

  const queryResult = useMemo(
    () => ({
      ...query,
      pages: query.data.pages.map((page) => ({
        items: page.bids,
      })),
    }),
    [query],
  )

  return useInfiniteTableItems(queryResult)
}
